import LayoutRoute from './LayoutRoute'

function processRelationship( molten, relationship, options ) {
  const { blueprint } = relationship

  if ( blueprint.type === 'mold' ) {
    LayoutRoute.create( molten, {
      id : 'tpi.store.CycleTimeMonitoring',
      relationship,
      layoutName : 'Cycle Time Monitoring',
      icon : 'fa-solid fa-grid-2',
      layout : {
        sort : 'z.1',
      },
      matches : { 
        use : 'navBar',
        client : 'ItemScreen',
        objectType : 'mold',
        path : 'location.molds'
      },
      linkPath : `${relationship.urlPath}/:moldId/cycleTimeMonitoring`,
      isItem : true,
      embed : true,
    } )
  }

  if ( blueprint.type === 'location' ) {
    LayoutRoute.create( molten, {
      id : 'tpi.store.FactoryCycleTimeMonitoring',
      relationship,
      layoutName : 'Cycle Time Monitoring',
      icon : 'fa-solid fa-grid-2',
      layout : {
        sort : 'a.3',
        sectionName : 'Factory Floor'
      },
      matches : { 
        use : 'navBar',
        client : 'ItemScreen',
        objectType : 'location',
        path : 'location'
      },
      linkPath : `${relationship.urlPath}/:locationId/factoryCycleTimeMonitoring`,
      isItem : true,
      embed : true,
      customQuery : 't-location'
    } )

    LayoutRoute.create( molten, {
      id : 'tpi.store.EmbedFactoryCycleTimeMonitoring',
      relationship,
      layoutName : 'Embed Cycle Time Monitoring',
      icon : 'fa-solid fa-grid-2',
      layout : {
        sort : 'a.4',
        sectionName : 'Factory Floor'
      },
      matches : { 
        use : 'navBar',
        client : 'ItemScreen',
        objectType : 'location',
        path : 'location'
      },
      linkPath : `${relationship.urlPath}/:locationId/embedFactoryCycleTimeMonitoring`,
      isItem : true,
      embed : true,
      customQuery : 't-location'
    } )
  }
}

export default {
  id : 'tpi.store.BlueprintRouteCreator',
  type : 'tpi.store.BlueprintRouteCreator',
  processRelationship,
}
